import { useEffect, useRef, useState } from 'react';
import {
  ITransactionFieldError,
  TransactionErrorField,
} from '../../../helpers/transactionCreationErrorHelper';

interface UseTransactionFieldErrorProps {
  transactionFieldError: ITransactionFieldError | null;
  clearTransactionFieldError: () => void;
  matterId: string | undefined;
  transactionDate: string;
}

export const useTransactionFieldError = ({
  transactionFieldError,
  clearTransactionFieldError,
  matterId,
  transactionDate,
}: UseTransactionFieldErrorProps) => {
  const errorFieldRef = useRef<HTMLDivElement>(null);
  // Raised before the request is sent — the posting period gate blocks the save locally
  const [postingPeriodErrorMessage, setPostingPeriodErrorMessage] = useState<string | null>(null);

  // The failure belongs to the value that was submitted, so editing either field retires it
  useEffect(() => {
    clearTransactionFieldError();
    setPostingPeriodErrorMessage(null);
  }, [matterId, transactionDate]);

  // The submit button sits below the fold, so the failing field is usually off screen
  useEffect(() => {
    if (!transactionFieldError && !postingPeriodErrorMessage) return;
    errorFieldRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [transactionFieldError, postingPeriodErrorMessage]);

  const getFieldErrorMessage = (field: TransactionErrorField) =>
    transactionFieldError?.field === field ? transactionFieldError.message : null;

  return {
    errorFieldRef,
    showTransactionDateError: setPostingPeriodErrorMessage,
    matterErrorMessage: getFieldErrorMessage(TransactionErrorField.MATTER),
    transactionDateErrorMessage:
      getFieldErrorMessage(TransactionErrorField.TRANSACTION_DATE) ?? postingPeriodErrorMessage,
  };
};
